import './model.scss';
import './phoneModel.scss'
interface ModelProps {
    isShowBack?: boolean;//返回按钮
    isShowClose?: boolean;//关闭按钮
    title?: string;//标题
    desc?: string;//描述
    descNode?: React.ReactNode;//描述节点
    isMobileType?: boolean;//是否是移动端
    isPhone?: boolean;//是否是手机端
    content: React.ReactNode;//内容
    width?: string;//宽度
    height?: string;//高度
    isScroll?: boolean;//是否是滚动
    onBackEvent?: () => void;//返回事件
    onCloseEvent?: () => void;//关闭事件
}
const Model = ({isShowBack,isShowClose,title, desc, descNode, isMobileType, isPhone, content, width, height, isScroll, onBackEvent, onCloseEvent}: ModelProps) => {
    return (
        // 小屏幕电脑
        <div className={`model-main ${isMobileType ? 'model-main-mobile' : ''}`}>
            {/* 是手机 */}
            <div 
            style={{width:width, height:height}}
            className={`model-content ${isMobileType && isPhone ? 'model-content-phone' : ''} ${isScroll ? 'model-content--phone-isScroll' : ''}`}
            >
                <div className="model-header" style={{justifyContent:isShowBack ? '' : 'flex-end'}}>
                    {
                        isShowBack && <img 
                        className="back-btn"
                        src={require('../../../assets/icons/model_back.png')} alt="back"
                        onClick={onBackEvent}/>
                    }
                    {
                        isShowClose && <img 
                        className="close-btn" 
                        src={require('../../../assets/icons/model_close.png')} 
                        alt="close" 
                        onClick={onCloseEvent} />
                    }
                </div>
                <div className={`all-model-content ${isScroll ? 'all-model-content-isScroll' : ''}`}>
                    {
                        title && <div className="title">{title}</div>
                    }
                    {
                        desc && <div className="desc">{desc}</div>
                    }
                    {
                        descNode && <>
                            {descNode}
                        </>
                    }
                    <div className="model-content-info">
                        {content}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Model;